import { render, staticRenderFns } from "./yilaodian.vue?vue&type=template&id=b89c8eec&scoped=true"
import script from "./yilaodian.vue?vue&type=script&lang=js"
export * from "./yilaodian.vue?vue&type=script&lang=js"
import style0 from "./yilaodian.vue?vue&type=style&index=0&id=b89c8eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89c8eec",
  null
  
)

export default component.exports